import React from 'react';
import { NavLink } from "react-router-dom";

const Header = () => {
  return (
    <div className="respoonsiveHeader">
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <NavLink className="navbar-brand" exact to="/">
          <img src="images/logo.svg" alt="" />
        </NavLink>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
          aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <img src="images/menu_icons.svg" alt="Hamburger" />
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item active">
              <NavLink className="nav-link" exact to="/">Home</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" exact to="/ingredients">Ingredients</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" exact to="/recipes">Recipes</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" exact to="/stake">Stake</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" exact to="/claim">Claim</NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default Header;
